'use strict';

import raven from 'raven';
import angular from 'angular';
import Promise from 'bluebird';

import FormController from 'app/controllers/form';
import Config from 'config';
import ClientDataController from './client-data.controller';
import ClientDataTpl from './client-data.html';

class ReceiptController extends FormController {
  /* @ngInject */
  constructor(
    ReceiptsService,
    ClientsService,
    QuotesService,
    EmployeesService,
    Receipt,
    VehiclesService,
    LoopBackAuth,
    $scope,
    $window,
    $mdDialog,
    $mdToast,
    $state
  ) {
    let receipt = $scope.$parent.$resolve.receipt;
    super(receipt, 'Recibo', ReceiptsService, null, 'receipts');
    this.user = $scope.$parent.$resolve.user;

    Object.assign(this, {
      ReceiptsService,
      ClientsService,
      QuotesService,
      EmployeesService,
      Receipt,
      VehiclesService,
      LoopBackAuth,
      $scope,
      $window,
      $mdDialog,
      $mdToast,
      $state
    });
    this.neverEditable = true;

    this.selectedQuotes = {};
    this.selectedQuotesAmount = {};
    this.selectedQuotesExtraItemDesc = {};

    if (this.user.isAdmin && !this.model.id) {
      this.canChangeEmployee = true;
    }

    // when url contains ?quoteId=123
    this.initialQuote = $scope.$parent.$resolve.initialQuote;
  }

  $onInit() {
    super.$onInit();
    this.client = this.model.client;
    this.employee = this.model.employee || this.user.employee;
    this.paymentItems = this.model.paymentItems || [];
    // avoid TypeError: Converting circular structure to JSON
    delete this.model.paymentItems;

    (this.model.quotes || []).forEach(q => {
      this.selectedQuotes[q.id] = true;
    });
    this.clientQuotes = this.model.client ? this.model.client.quotes : [];
    if (this.initialQuote) {
      this.selectedQuotes[this.initialQuote.id] = true;
      this.clientQuotes.push(this.initialQuote);
      this.client = this.initialQuote.client;
    }

    if (!this.model.date) {
      this.model.date = new Date();
    }

    // default canBeCollected: true
    if (!this.model.id) this.model.canBeCollected = true;
    this.updateTotal();
    this.updateTotalPending();
  }

  onPaymentItemChange($event) {
    this.updateTotal();
    this.updateAssociatedAmounts();

    if ($event.attribute && $event.attribute == 'type') {
      if (this.isMissingClientData()) {
        return this.simpleError(`ATENCION: al cliente le faltan datos \
para poder emitir factura. Serán preguntados al momento de guardar este \
recibo`);
      }
    }
  }

  updateTotal() {
    this.total = this.paymentItems.reduce((sum, pi) => {
      return sum + pi.amount;
    }, 0);
    if (isNaN(this.total)) this.total = 0;
  }

  updateTotalPending() {
    this.totalPending = this.getSelectedQuotes().reduce((sum, q) => {
      return sum + (q.totalFinalAmount - q.totalReceiptsAmount);
    }, 0);
    if (isNaN(this.totalPending)) this.total = 0;
  }

  getTotalAssociatedAmounts() {
    return this.getSelectedQuotes().reduce((sum, q) => {
      return sum + this.selectedQuotesAmount[q.id];
    }, 0);
  }

  isMissingClientData() {
    let missingClientData =
      !this.client.cuit ||
      !this.client.legalAddress.streetName ||
      !this.client.legalAddress.cityId ||
      !this.client.vatType;

    return missingClientData;
  }

  askForMissingClientData() {
    return this.$mdDialog
      .show({
        controller: ClientDataController,
        template: ClientDataTpl,
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          client: this.client
        }
      })
      .then(() => {
        return this.ClientsService.save(this.client).catch(err => {
          this.simpleError(`No se pudo guardar el cliente`);
          return Promise.reject(err);
        });
      })
      .catch(err => {
        // eslint-disable-next-line
        console.debug(err);
        return Promise.reject(err);
      });
  }

  save() {
    if (this.form.$valid) {
      let someSelected = Object.keys(this.selectedQuotes).some(
        k => this.selectedQuotes[k]
      );
      if (!someSelected) {
        return this.simpleError(`Se debe imputar al menos a un presupuesto`);
      }

      if (!this.paymentItems.length) {
        return this.simpleError(`Se debe ingresar al menos un valor recibido`);
      }

      if (this.total < this.getTotalAssociatedAmounts()) {
        return this.simpleError(
          `El monto de los valores recibidos es menor a \
las imputaciones`
        );
      }

      if (this.total > this.getTotalAssociatedAmounts()) {
        return this.$mdDialog.show(
          this.$mdDialog
            .alert()
            .clickOutsideToClose(true)
            .title('Se debe imputar la totalidad del monto')
            .textContent(
              `Por favor impute a las OTs seleccionadas
la totalidad del monto del recibo`
            )
            .ok('Aceptar')
        );
      }

      return Promise.resolve()
        .then(() => {
          if (!this.isMissingClientData()) return Promise.resolve();

          // Ask for missing client data
          return this.askForMissingClientData();
        })
        .then(() => {
          // TODO: make sure on server side
          if (this.paymentItems.some(p => p.type == 'bankTx')) {
            this.model.canBeCollected = false;
          }

          /* TODO: check that payment items amount total is enough
                   to impute all of the selected quotes
                */

          let firstTimeSave = this.model.id ? false : true;
          this.showSpin = true;
          this.model.clientId = this.client.id;
          return this.ReceiptsService.createNew({
            receipt: this.model,
            quotes: this.getSelectedQuotes(),
            paymentItems: this.paymentItems
          }).then(
            data => {
              Object.assign(this.model, data.receipt);
              this.clientQuotes = data.receipt.quotes;
              this.updateTotalPending();
              this.showSpin = false;
              this.editable = true;
              this.editing = false;
              if (firstTimeSave) this.updateLocation();
            },
            err => {
              // eslint-disable-next-line
              console.error(err);
            }
          );
        })
        .catch(err => {
          // eslint-disable-next-line
          console.error(err);
        });
    } else {
      // pass
    }
  }

  queryHolderSearch() {
    return this.ClientsService.findByText(this.searchHolderText);
  }

  selectedHolderChange(client) {
    if (client) {
      this.model.client = client;
      this.client = client;
      this.vehicle = null;
      this._updateQuotes();
    }
  }

  queryVehicleSearch() {
    return this.VehiclesService.getModels({
      where: {
        broad: this.searchVehicleText
      },
      order: 'plate DESC, number DESC, description DESC'
    }).then(vehicles => {
      return vehicles.map(v => {
        v.fullDesc = `${v.plate} - ${v.number} - ${v.description}`;
        return v;
      });
    });
  }

  // eslint-disable-next-line no-unused-vars
  selectedVehicleChange(vehicle) {
    this.holder = null;
    this._updateQuotes();
  }

  _updateQuotes() {
    let where = [
      {
        approvedAt: {
          neq: null
        },
        groupInvoiceId: null
      }
    ];
    if (this.holder) {
      where.push({
        holderId: this.holder.id
      });
    } else if (this.vehicle) {
      where.push({
        vehicleId: this.vehicle.id
      });
    }
    if (this.dateFrom) {
      where.push({
        createdAt: {
          gte: this.dateFrom
        }
      });
    }
    if (this.dateTo) {
      where.push({
        createdAt: {
          lt: this.dateTo
        }
      });
    }
    this.showSpin = true;
    return this.QuotesService.find({
      filter: {
        where: {
          and: where
        },
        include: ['client', 'vehicle', 'holder', 'procedures'],
        order: 'approvedAt ASC'
      }
    }).then(quotes => {
      this.showSpin = false;
      this.clientQuotes = quotes;
    });
  }

  queryEmployeeSearch() {
    return this.EmployeesService.find({
      filter: {
        where: {
          name: {
            regexp: `^${this.searchEmployeeText}/i`
          }
        }
      }
    });
  }

  selectedEmployeeChange(employee) {
    if (employee) {
      this.model.employee = employee;
      this.employee = employee;
    }
  }

  getSelectedQuotes() {
    /* TODO: we're adding extra properties to a quote object, that can get
           messy */
    let selectedQuotes = this.clientQuotes.filter(q => {
      return Object.keys(this.selectedQuotes).some(id => {
        /* Is quote selected (contains a truthy value) and
                   matches? */
        return this.selectedQuotes[id] && id == q.id;
      });
    });
    // add associatedAmount
    selectedQuotes.forEach(q => {
      q.associatedAmount = this.selectedQuotesAmount[q.id];
    });

    // add extra item desc when required
    Object.keys(this.selectedQuotesExtraItemDesc).forEach(id => {
      let desc = this.selectedQuotesExtraItemDesc[id];
      let quote = selectedQuotes.find(q => q.id == id);
      if (quote) {
        quote.extraItemDesc = desc;
      } else {
        const err = `There's an extra item desc for quote ${id} but \
we couldn't find it in selectedQuotes`;
        raven.captureMessage(err, {
          quoteId: id,
          selectedQuotes: selectedQuotes
        });
      }
    });
    return selectedQuotes;
  }

  onSelectedQuoteChange(quote) {
    if (this.selectedQuotes[quote.id]) {
      // checking
      let selectedQuotes = this.getSelectedQuotes();
      let isThereOtherClient = selectedQuotes.some(
        q => q.client.id != quote.client.id
      );
      if (isThereOtherClient) {
        this.selectedQuotes[quote.id] = false;
        this.simpleError(`El presupuesto pertenece a un cliente distinto \
a los ya seleccionados`);
      } else {
        this.client = this.model.client = quote.client;
      }
    } else {
      // unchecking
      if (!this.selectedQuotes.length) this.client = this.model.client = null;
    }
    this.updateTotalPending();
  }

  addPaymentItem() {
    let paymentItem = this.ReceiptsService.createPaymentItem({
      receipt: this.model
    });
    this.paymentItems.push(paymentItem);
    this.updateTotal();
    this.updateAssociatedAmounts();
  }

  removePaymentItem($event) {
    let paymentItem = $event.paymentItem;
    let index = this.paymentItems.findIndex(
      p => p.$$hashKey == paymentItem.$$hashKey
    );
    if (index > -1) {
      this.paymentItems.splice(index, 1);
    }
    this.updateTotal();
    this.updateAssociatedAmounts();
  }

  updateAssociatedAmounts() {
    // Assumes this.total is up to date
    let total = this.total;
    Object.keys(this.selectedQuotes).forEach(id => {
      let quote = this.clientQuotes.find(q => q.id == id);
      let pending = quote.totalFinalAmount - quote.totalReceiptsAmount;
      // cap associated amount to our total
      let toApply = pending > total ? total : pending;
      this.selectedQuotesAmount[id] = toApply;
      total -= toApply;
    });
  }

  void(ev) {
    var confirm = this.$mdDialog
      .prompt()
      .title('Anulación de Recibo')
      .textContent('Ingrese el motivo')
      .placeholder('Motivo de anulación')
      .ariaLabel('Motivo de anulación')
      .required(true)
      .targetEvent(ev)
      .ok('Anular el recibo')
      .cancel('Cancelar');

    this.$mdDialog.show(confirm).then(result => {
      this.showVoidSpin = true;
      this.model
        .$prototype$void({
          reason: result
        })
        .then(() => {
          this.showVoidSpin = false;
          this.model.deletionReason = result;
          this.model.deletedAt = new Date();
        });
    });
  }

  pdf() {
    let url = `${Config.publicUrl}/api/Receipts/pdf?id=${this.model.id}&\
access_token=${this.LoopBackAuth.accessTokenId}`;
    this.$window.open(url);
  }

  getClientName(client) {
    if (client) return client.lastName + ' ' + client.name;
  }

  getProceduresDisplay(procedures) {
    if (!procedures) {
      return '';
    }
    return procedures.map(p => p.description).join(', ');
  }
}

export default ReceiptController;
